// Release only after the checks in scripts/check_planning_tools.mjs pass.
// Preview is server-only, opt-in, noindex and never included in the sitemap.
export const PLANNING_PAGES = [
  { id: "reaction_day", path: "/reaction-time-by-time-of-day", area: "everyday-brain", art: "reaction" },
  { id: "gaming_sleep", path: "/tools/gaming-sleep-planner", area: "sleep", art: "sleep" },
  { id: "deep_work", path: "/tools/deep-work-calculator", area: "focus", art: "deep" },
  { id: "meeting_load", path: "/tools/meeting-load-calculator", area: "focus", art: "meeting" },
  { id: "energy_curve", path: "/tools/energy-curve-planner", area: "everyday-brain", art: "energy" },
] as const;

export type PlanningId = (typeof PLANNING_PAGES)[number]["id"];
export type PlanningPage = (typeof PLANNING_PAGES)[number];

// Verified in scripts/planning_qa_report.json. To hide again, put "/tools"
// and ...PLANNING_PAGES.map((p) => p.path) back in this set.
export const PLANNING_NOT_LIVE = new Set<string>([]);
export const planningLive = (path: string) => !PLANNING_NOT_LIVE.has(path);
export const planningAvailable = (path: string) => planningLive(path) || process.env.PLANNING_PREVIEW === "1";

// English first. Future translations use /<locale>/tools/<slug>, never a
// second root hub. The translation checker explicitly permits this namespace.
export const PLANNING_AREAS = ["sleep", "study", "focus", "calm", "music", "everyday-brain"] as const;
